"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLiveProjectSnapshot = toLiveProjectSnapshot;
exports.isLiveProjectSnapshot = isLiveProjectSnapshot;
const case_payment_status_helpers_js_1 = require("../case-workflow/case-payment-status.helpers.js");
const case_workflow_helpers_js_1 = require("../case-workflow/case-workflow.helpers.js");
const revision_gating_js_1 = require("./revision-gating.js");
function storedCaptured(value) {
    if (value == null || !Number.isFinite(Number(value)))
        return undefined;
    return Number(value);
}
function resolveLiveInvoice(milestone, invoices) {
    const invoiceId = milestone.projectInvoiceId || milestone.invoice?.id || null;
    if (invoiceId) {
        const fromList = invoices.find((item) => item.id === invoiceId);
        if (fromList)
            return fromList;
    }
    return milestone.invoice ?? undefined;
}
function releasedAmountForMilestone(milestone, invoice) {
    const drawdown = Number(milestone.drawdownAmount || 0);
    if (!(0, case_workflow_helpers_js_1.isCaseWorkflowInvoice)(invoice))
        return drawdown;
    return (0, case_payment_status_helpers_js_1.getCaseMilestoneEscrowAmounts)({
        budgetAmount: Number(milestone.budgetAmount || 0),
        paymentRequestStatus: milestone.paymentRequestStatus,
        projectInvoiceId: milestone.projectInvoiceId || invoice?.id,
        invoice,
        drawdownAmount: drawdown,
    }, invoice ? [invoice] : []).released;
}
function toLiveProjectSnapshot(input) {
    const invoices = input.invoices ?? [];
    const milestones = input.milestones ?? [];
    return {
        startDate: input.startDate,
        endDate: input.endDate,
        disputing: input.disputing === true || input.status === "disputing",
        milestones: milestones.map((milestone) => {
            const invoice = resolveLiveInvoice(milestone, invoices);
            const releasedAmount = releasedAmountForMilestone(milestone, invoice);
            return {
                id: milestone.id,
                name: milestone.name,
                description: milestone.description,
                budgetAmount: Number(milestone.budgetAmount || 0),
                startDate: milestone.startDate,
                endDate: milestone.endDate,
                status: milestone.status,
                moneyState: (0, revision_gating_js_1.resolveRevisionMoneyState)({
                    invoicePaid: String(invoice?.status || "").toLowerCase() === "paid",
                    releasedAmount,
                    budgetAmount: Number(milestone.budgetAmount || 0),
                    paymentRequestStatus: milestone.paymentRequestStatus,
                    instantRelease: invoice?.instantRelease === true,
                }),
                projectInvoiceId: milestone.projectInvoiceId || invoice?.id,
                drawdownAmount: Number(milestone.drawdownAmount || 0),
                releasedAmount,
                subMilestones: (milestone.subMilestones ?? []).map((sub) => {
                    const approved = String(sub.paymentRequestStatus || "").toLowerCase() === "approved";
                    const budget = Number(sub.budgetAmount || 0);
                    const drawdown = Number(sub.drawdownAmount || 0);
                    return {
                        id: sub.id,
                        parentMilestoneId: milestone.id,
                        name: sub.name,
                        description: sub.description,
                        budgetAmount: budget,
                        startDate: sub.startDate,
                        endDate: sub.endDate,
                        status: sub.status,
                        projectInvoiceId: sub.projectInvoiceId ?? null,
                        // Approved sub releases leave escrow even when drawdownAmount is unset on the sub row.
                        releasedAmount: approved ? budget : drawdown,
                    };
                }),
            };
        }),
        invoices: invoices.map((invoice) => ({
            id: invoice.id,
            status: invoice.status,
            dueDate: invoice.dueDate,
            invoiceCode: invoice.invoiceCode ?? null,
            milestoneAmountCaptured: storedCaptured(invoice.milestoneAmountCaptured),
            milestoneIds: milestones
                .filter((milestone) => (milestone.projectInvoiceId || milestone.invoice?.id) === invoice.id)
                .map((milestone) => milestone.id),
            adjustmentIds: (input.adjustments ?? []).filter((adjustment) => adjustment.invoiceId === invoice.id).map((adjustment) => adjustment.id),
        })),
        adjustments: (input.adjustments ?? []).map((adjustment) => ({
            id: adjustment.id,
            amount: Number(adjustment.amount || 0),
            kind: adjustment.kind,
            status: adjustment.status,
            description: adjustment.description ?? undefined,
            reason: adjustment.reason ?? undefined,
            invoiceId: adjustment.invoiceId,
            revisionId: adjustment.revisionId,
            displayCode: adjustment.displayCode ?? undefined,
            createdAt: adjustment.createdAt,
        })),
    };
}
function isLiveProjectSnapshot(value) {
    if (!value || typeof value !== "object")
        return false;
    const row = value;
    return Array.isArray(row.milestones) && Array.isArray(row.invoices) && Array.isArray(row.adjustments);
}
